/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontAboutSection_seller$ref = any;
type StorefrontArticleSection_seller$ref = any;
type StorefrontFeaturedSection_seller$ref = any;
type StorefrontMediaSection_seller$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHome_seller$ref: FragmentReference;
export type StorefrontHome_seller = {|
  +$fragmentRefs: StorefrontAboutSection_seller$ref & StorefrontMediaSection_seller$ref & StorefrontArticleSection_seller$ref & StorefrontFeaturedSection_seller$ref,
  +$refType: StorefrontHome_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontHome_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontAboutSection_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontMediaSection_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontArticleSection_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_seller",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a142c6465ca03df1e7974b2e95cb721c';
module.exports = node;
